import React, { useEffect, useRef } from 'react';
import { Select } from 'antd';

interface AgDropdownEditorProps {
  value: string;
  api: any;
  column: any;
  node: any;
  options: { label: string; value: string }[];
  placeholder?: string;
  stopEditing: () => void;
}

const AgDropdownEditor: React.FC<AgDropdownEditorProps> = (props) => {
  const { value, column, node, options, placeholder, stopEditing } = props;
  const ref = useRef<any>(null);

  useEffect(() => {
    setTimeout(() => {
      ref.current?.focus?.();
    }, 0);
  }, []);

  const handleChange = (val: string | undefined) => {
    if (val !== undefined) {
      node.setDataValue(column.getColId(), val);
    }
    stopEditing();
  };

  return (
    <Select
      ref={ref}
      value={value}
      options={options.filter(opt => opt.value !== null)}
      onChange={handleChange}
      placeholder={placeholder || 'Select...'}
      dropdownMatchSelectWidth={false}
      style={{ width: '100%' }}
    />
  );
};

export default AgDropdownEditor;
